export const getStoryblokResizedUrl = (url: string, width: number, quality: number, storyblokUrl: string) => {
  url = url.replace('//a.storyblok.com/f/234504', storyblokUrl.replace('https://', '//'));
  if (url.includes(storyblokUrl)) {
    // SVG: no raster transform. GIF: keep original so animation isn't flattened.
    if (/\.(svg|gif)(\?|$)/i.test(url)) return url;
    // Force WebP — quality filters are a no-op on PNG and Accept negotiation
    // is inconsistent (SSR preload, bots, some lab tools still get PNG).
    return `${url}/m/${width}x0/filters:format(webp):quality(${quality})`;
  }

  const s = url.includes('?') ? '&' : '?';
  return `${url}${s}w=${width}`;
};
